import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 10px',
      padding: 0,
      maxWidth: 94,
      width: '100%',
      minHeight: 120,
      border: `1px solid ${theme.palette.grey.A200}`,
      borderRadius: 3,
      background: theme.palette.background.default,
      color: theme.palette.secondary.main,
      '&:hover': {
        border: `3px solid ${theme.palette.secondary.main}`,
      },
      [theme.breakpoints.down('xs')]: {
        margin: '0 7px',
        maxWidth: 70,
        width: '100%',
        minHeight: 94,
      },
    },
    label: {
      flexDirection: 'column',
      whiteSpace: 'normal',
    },
    outlinedPrimary: {
      '&:hover': {
        '@media (hover: none)': {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
  }),
);

interface Props {
  onClick: (props: any) => void;
  className?: string;
}

const ChoiceButton: React.FC<Props> = ({ onClick, children, className, ...rest }) => {
  const classes = useStyles();

  return (
    <Button
      onClick={(e) => onClick(e)}
      variant="outlined"
      color="secondary"
      classes={{
        root: classes.root,
        label: classes.label,
        outlinedPrimary: classes.outlinedPrimary,
      }}
      className={className}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ChoiceButton;
